<template>
	<section class="calendar-container">
		<div class="btn-container">
			<p>
				{{ week[0].number }} {{ week[0].month }} - {{ week[6].number }}
				{{ week[6].month }} {{ week[0].formatedDate.slice(0, 4) }}
			</p>
			<div class="calendar__selector">
				<button @click="prev">
					<img src="/img/calendar/left-arrow.svg" alt="" />
				</button>
				<button @click="today">Aujourd'hui</button>
				<button @click="next">
					<img src="/img/calendar/right-arrow.svg" alt="" />
				</button>
			</div>
		</div>

		<calendar-header :week="week" />
		<div v-if="loaded" class="calendar-day-container">
			<calendar-hour />
			<calendar-day
				v-for="day in week"
				:key="day"
				:events="getEvents(day)"
				:day="day"
				:indicator="checkDate(day)"
			/>
		</div>
		<div class="calendar-loader-container" v-else-if="isLoading">
			<loader />
		</div>
	</section>
</template>

<script>
import { allActivitiesService } from '../../../services/activitiesService'
import { allExerciseSheetsService } from '../../../services/exerciseSheetsService'
import { allAgendasService } from '../../../services/agendasService'
import Loader from '../../Loader.vue'
import CalendarDay from './CalendarDay.vue'
import CalendarHeader from './CalendarHeader.vue'
import CalendarHour from './CalendarHour.vue'
export default {
	components: { CalendarHeader, CalendarDay, CalendarHour, Loader },
	data() {
		return {
			week: [],
			agendas: [],
			evaluations: [],
			activities: [],
			exerciseSheets: [],
			events: [],
			date: new Date(),
			loaded: false,
			isLoading: false
		}
	},

	methods: {
		checkDate(day) {
			if (day.formatedDate == this.computedDate()) {
				return true
			}
			else {
				return false
			}
		},
		computedDate() {
			let date = new Date()
			return date.toISOString().split('T')[0]
		},
		getEvents(day) {
			let events = this.events.filter(x => x.day == day.formatedDate)

			if (events && events.length > 0) {
				return events
			}
			else {
				return []
			}

		},
		async next() {
			this.date.setDate(this.date.getDate() + 5)
			this.getDate()
			await this.allAgendas()
		},
		async prev() {
			this.date.setDate(this.date.getDate() - 9)
			this.getDate()
			await this.allAgendas()
		},
		async today() {
			this.date = new Date()
			this.getDate()
			await this.allAgendas()
		},
		getDate() {
			let week = []
			this.date.setDate(this.date.getDate() - this.date.getDay() + 1)
			for (let i = 0; i < 7; i++) {
				const date = new Date(this.date)
				week.push(
					{
						day: date.toLocaleDateString('fr', { weekday: "long" }),
						number: date.toLocaleDateString('fr', { day: "2-digit" }),
						month: date.toLocaleDateString('fr', { month: "long" }),
						formatedDate: date.toISOString().split('T')[0],
					}
				)
				this.date.setDate(this.date.getDate() + 1)
			}
			this.week = week
		},

		allAgendas: async function () {
			// utiliser l'endpoint agendas (emploi du temps) — correspond à l'édition
			this.agendas = await allAgendasService()
			// éviter de doubler les events si la fonction est rappelée
			this.events = []
			// pour le support des récurrences, on étend chaque agenda selon sa "currency"
			for (let agenda of this.agendas) {
				let activity = this.activities.find(x => x.id == agenda.activity) || ''
				let evaluation = this.evaluations.find(x => x.id == agenda.evaluation) || ''
				let exerciseSheet = this.exerciseSheets.find(x => x.id == agenda.exercise_sheet) || ''
				const base = {
					activity: agenda.activity,
					evaluation: agenda.evaluation,
					exerciseSheet: agenda.exercise_sheet,
					start: agenda.debut_hour,
					end: agenda.end_hour,
					title: activity.name || evaluation.title || exerciseSheet.title,
					class: agenda.classroom,
					id: agenda.id
				}

				const agendaStart = new Date(agenda.day)
				const currency = agenda.currency || 'OCCASIONAL'
				for (let dayObj of this.week) {
					const targetDate = new Date(dayObj.formatedDate)
					let shouldAdd = false

					if (currency === 'WEEKLY') {
						// ajouter si même jour de la semaine
						if (agendaStart.getDay() === targetDate.getDay()) {
							shouldAdd = true
						}
					}
					else if (currency === 'BIWEEKLY') {
						if (agendaStart.getDay() === targetDate.getDay()) {
							const daysDiff = Math.round((targetDate - agendaStart) / (24 * 3600 * 1000))
							if (daysDiff >= 0) {
								const weeks = Math.floor(daysDiff / 7)
								if (weeks % 2 === 0) shouldAdd = true
							}
						}
					}
					else {
						// OCCASIONAL ou autre: n'apparait que le jour exact
						if (agenda.day === dayObj.formatedDate) shouldAdd = true
					}

					if (shouldAdd) {
						const data = {
							...base,
							day: dayObj.formatedDate,
							dateStart: `${dayObj.formatedDate} ${agenda.debut_hour}`,
							dateEnd: `${dayObj.formatedDate} ${agenda.end_hour}`,
						}
						this.events.push(data)
					}
				}
			}
		},
		allActivities: async function () {
			this.activities = await allActivitiesService()
		},

		allExerciseSheets: async function () {
			this.exerciseSheets = await allExerciseSheetsService()
		},
	},


	async created() {
		this.isLoading = true
		this.getDate()
		await this.allActivities()
		await this.allExerciseSheets()
		await this.allAgendas()
		this.isLoading = false
		this.loaded = true
	},
}
</script>

<style>
</style>
